import script from "./HrFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./HrFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./HrFormDialog.vue?vue&type=style&index=0&id=7a88da6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a88da6c"]])

export default __exports__